import { FileOutlined, FolderOutlined } from '@ant-design/icons';
import React from 'react';
import styled, { css } from 'styled-components';

const iconStyle = css`
  font-size: 22px;
  opacity: 0.6;
`;

const FileIcon = styled(FileOutlined)`
  ${iconStyle}
`;

const FolderIcon = styled(FolderOutlined)`
  ${iconStyle}
`;

export interface AssetTypeIconProps {
  assetType?: string;
}

function AssetTypeIcon({ assetType }: AssetTypeIconProps) {
  return assetType === 'folder' ? <FolderIcon /> : <FileIcon />;
}

export default AssetTypeIcon;
